import styled from 'styled-components';

export const PluginsListContainer = styled.div`
  min-width: 280px;
  width: 770px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  overflow: auto;
`;

export const PluginBox = styled.button`
  font-family: inherit;
  border-width: 0;
  text-align: left;
  display: flex;
  flex-direction: column;

  padding: 15px;
  cursor: pointer;
  margin-left: 20px;
  margin-bottom: 20px;
  width: 230px;
  border-radius: 4px;
  background-color: ${(props) => props.theme['plugin.bg.color']};
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.08), 0 4px 6px 0 rgba(50,50,93,0.11);
  transition: all 0.3s ease;

  &:focus {
    outline-width: 0;
    box-shadow: ${(props) => props.theme['modal.plugin.shadow']};
  }
`;

export const PluginBoxHeader = styled.div`
  height: 23px;
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 600;
  align-items: center;
  display: flex;
`;

export const PluginBoxTitle = styled.span`
  padding-left: 9px;
  color: ${(props) => props.theme['plugin.header.color']};
`;

export const PluginBoxDescription = styled.div`
  margin-top: 14px;
  flex: auto;

  color: ${(props) => props.theme['plugin.description.color']};
  font-size: 14px;
`;

export const PluginBoxVersion = styled.div`
  margin-top: 18px;
  height: 14px;

  color: ${(props) => props.theme['plugin.version.color']};
  font-size: 12px;
  line-height: 14px;
`;
